import { createContext } from 'react';
import type { ExtractedAnswersAPI } from '@trinity/chat';

export type GetExtractedAnswersAPI = (
  data: ExtractedAnswersAPI.GetExtractedAnswers.Request
) => Promise<ExtractedAnswersAPI.GetExtractedAnswers.Response>;

export type RefreshExtractedAnswersAPI = (
  data: ExtractedAnswersAPI.RefreshExtractedAnswers.Request
) => Promise<ExtractedAnswersAPI.RefreshExtractedAnswers.Response>;

export type ExtractedAnswersAPIContextValue = {
  getExtractedAnswers: GetExtractedAnswersAPI;
  refreshExtractedAnswers: RefreshExtractedAnswersAPI;
};

export const ExtractedAnswersAPIContext = createContext<ExtractedAnswersAPIContextValue | null>(null);

ExtractedAnswersAPIContext.displayName = 'ExtractedAnswersAPIContext';
